import React from 'react';
import classNames from 'classnames/bind';
import { MentionsInput, Mention } from 'react-mentions';

import useMentionableAsset from 'buyside/components/container/Mentionable/useMentionableAsset';

import styles from './chatterboxStyles.scss';

const cx = classNames.bind(styles);

const Chatterbox: React.FC<{
  onChange: (value: string) => void;
  value: string;
  placeholder: string;
}> = ({ onChange, value, placeholder }): React.ReactElement => {
  const [mentionableAssets, markup, renderSuggestion, displayTransform] = useMentionableAsset();

  const handleChange = (event: any): void => onChange(event.target.value);
  const handleBoxClick = (): void => document.getElementById('chatterbox-input')?.focus();

  const boxWrapStyle = cx({
    boxWrap: true,
    hasUserContent: value
  });

  return (
    <div className={boxWrapStyle} onClick={handleBoxClick} data-heap="share-user-insight">
      <MentionsInput
        value={value}
        onChange={handleChange}
        className="mentionsInput"
        id="chatterbox-input"
        placeholder={placeholder}
      >
        <Mention
          appendSpaceOnAdd
          data={mentionableAssets}
          displayTransform={displayTransform}
          markup={markup}
          renderSuggestion={renderSuggestion}
          trigger="$"
        />
      </MentionsInput>
    </div>
  );
};

export default Chatterbox;
